export enum FetchBeneficiaryRequirementsErrors {
    WRONG_COMBINATION = 'Given currency and country combination is not supported',
}

